import { render, staticRenderFns } from "./WithChat.vue?vue&type=template&id=48c4180f&scoped=true&"
import script from "./WithChat.vue?vue&type=script&lang=js&"
export * from "./WithChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c4180f",
  null
  
)

export default component.exports